<template>
  <div class="row" style="margin-top: 15px">
    <fieldset>
      <legend style="width: 250px">Pacientes por convênio</legend>
      <div class="row">
        <div class="title-group">Período</div>
        <div class="group-itens">
          <div class="item-filter">
            <a-date-picker show-time type="date" placeholder="Data Início" style="width: 100%" format="DD/MM/yyyy" v-model:value="form.dataInicio" />
          </div>
          <div class="item-filter">
            <a-date-picker show-time type="date" placeholder="Data Fim" style="width: 100%" format="DD/MM/yyyy" v-model:value="form.dataFim" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="title-group">Convênios</div>
        <div class="group-itens">
          <Multiselect v-model="form.objetoConsulta" display="chip" placeholder="Selecione Convênios" :maxSelectedLabels="3" class="w-10rem" :options="convenios"></Multiselect>
        </div>
      </div>
      <div class="row" style="margin-top: 15px">
        <div style="width: 180px">
          <a-tooltip title="Pesquisar" placement="top">
            <div class="input-group-prepend icon" style="text-align: center">
              <span class="input-group-text bg-white" @click="searchConvenio">
                <i class="fa fa-search" style="margin: 0px 10px"></i>
                <span>Pesquisar</span>
              </span>
            </div>
          </a-tooltip>
        </div>
        <div class="col"></div>
        <div style="display: flex; flex-direction: row; width: 380px">
          <div style="width: 150px">
            <a-tooltip title="Imprimir" placement="top" v-if="dataConvenioPaciente.length > 0" @click="imprimirPDF">
              <div class="input-group-prepend icon" style="text-align: center">
                <span class="input-group-text bg-white">
                  <i class="fa-solid fa-print" style="margin: 0px 10px"></i>
                  <span>Imprimir</span>
                </span>
              </div>
            </a-tooltip>
          </div>
          <div style="width: 170px">
            <a-tooltip title="Imprimir" placement="top" v-if="dataConvenioPaciente.length > 0" @click="encaminharEmail">
              <div class="input-group-prepend icon" style="text-align: center">
                <span class="input-group-text bg-white">
                  <i class="fa-solid fa-share" style="margin: 0px 10px"></i>
                  <span>Encaminhar</span>
                </span>
              </div>
            </a-tooltip>
          </div>
        </div>
      </div>
      <div class="row" style="margin-top: 10px">
        <a-table :dataSource="dataConvenioPaciente" :columns="columns"> </a-table>
      </div>
      <div id="iframe"></div>
    </fieldset>
  </div>
</template>
<script>
import { gerarRelatorioHtml, gerarRelatorioPdf } from '@/components/service/gerarRelatorio';
import { getConvenioAtendimentoRelatorio } from '@/components/service/registroAtendimentoService';
import { abrirImpressaoPorBlob, encaminharEmailTo, formatarData } from '@/utils/servicos-utils';

export default {
  name: 'PacienteConvenioRelatorio',
  data() {
    return {
      dataInicio: null,
      dataFim: null,
      dataConvenioPaciente: [],
      convenios: ['IPASGO', 'PARTICULAR', 'DOACAO'],
      form: {
        todos: false,
        objetoConsulta: [],
        dataInicio: null,
        dataFim: null,
        consultPac: true,
      },
      columns: [
        {
          title: 'Paciente',
          dataIndex: 'nome',
          key: 'nome',
        },
        {
          title: 'Convênio',
          dataIndex: 'descricao',
          key: 'descricao',
        },
        {
          title: 'Tipo Paciente',
          dataIndex: 'tipoPaciente',
          key: 'tipoPaciente',
        },
      ],
    };
  },

  methods: {
    async searchConvenio() {
      let dataInicio = this.form.dataInicio;
      let dataFim = this.form.dataFim;
      if (this.form.dataInicio != null) {
        this.form.dataInicio = formatarData(new Date(this.form.dataInicio), 'DD/MM/YYYY');
        if (this.form.dataFim != null) {
          this.form.dataFim = formatarData(new Date(this.form.dataFim), 'DD/MM/YYYY');
        }
      }
      await getConvenioAtendimentoRelatorio(this.form).then((r) => {
        this.form.dataInicio = dataInicio;
        this.form.dataFim = dataFim;
        this.dataConvenioPaciente = r.data;
      });
    },
    async imprimirPDF() {
      if (this.dataConvenioPaciente.length > 0) {
        await gerarRelatorioPdf({
          listaDadosDocumento: this.dataConvenioPaciente,
          nomeDocumentoHtml: 'relatorio-convenio-paciente.html',
        }).then((r) => {
          abrirImpressaoPorBlob(r.data);
        });
      }
    },
    async encaminharEmail() {
      if (this.dataConvenioPaciente.length > 0) {
        await gerarRelatorioHtml({
          listaDadosDocumento: this.dataConvenioPaciente,
          nomeDocumentoHtml: 'relatorio-convenio-paciente.html',
        }).then((r) => {
          encaminharEmailTo('Relatório de Paciente por Convenio', r.data);
        });
      }
    },
  },
};
</script>

<style scoped>
.title-group {
  margin-bottom: 5px;
  font-size: 16px;
  font-weight: bold;
}

.group-itens {
  display: flex;
  flex-direction: row;
}

.form-check-label {
  font-size: 14px;
  margin: 0px 10px;
}

.input-group-prepend {
  cursor: pointer;
}

.input-group-text {
  padding: 0.375rem 26px 4px 11px;
  height: 38px;
}

.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  background: #2bec96 !important;
}

.icon {
  cursor: pointer;
}

.item-filter {
  margin: 10px;
}

.item-filter.form-check-input {
  margin: 10px;
}
</style>
